<template>
    <div class="default-layout">
        <side-bar />
        <loader :show="$store.getters.loading"></loader>
        <div class="main">
            <modal-window
                    @submit="submitLicense"
                    @cancel="cancelLicense"
                    :submit-btn="{show:true, label:'Согласен'}"
                    :cancel-btn="{show:true, label:'Не согласен(покинуть сайт)'}"
                    v-if="showLicAgreement">
                <license-agreements/>
            </modal-window>
            <page-content>
                <breadcrumbs class="breadcrumbs" />
                <slot />
            </page-content>
            <help-block>
                <slot name="help-block"/>
            </help-block>
        </div>
    </div>
</template>

<script>
import SideBar from '../components/SideBar'
import PageContent from '../components/PageContent'
import HelpBlock from '../components/HelpBlock'
import Breadcrumbs from '../components/Breadcrumbs'
import ModalWindow from '../components/ModalWindow'
import LicenseAgreements from '../components/LicenseAgreements'
import Loader from "../components/Loader";

export default {
  components: {
    Loader,
    SideBar,
    PageContent,
    HelpBlock,
    Breadcrumbs,
    ModalWindow,
    LicenseAgreements
  },
  data() {
    return {
      showLicAgreement: !this.$store.getters.licenseAgreement //this temp var needs for animation
    }
  },
  methods: {
    async submitLicense() {
      await this.$store.dispatch('markUserAsLicenseAgreed')
    },
    cancelLicense() {
      this.$store.dispatch('logOut')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="sass" scoped>
    .default-layout
        width: 100vw
        height: 100vh
        background: $dark-blue

    .main
        display: flex
        align-items: center

    .help-block
        margin-left: gridSteps(8)
        margin-right: gridSteps(8)

    .breadcrumbs
        margin-bottom: gridSteps(4)
</style>
